module.exports = __webpack_public_path__ + "static/media/BAR.aeae4c37.svg";